import agentIcon from "./agentIcon.svg";
import slpIcon from "./slpIcon.svg";

export { agentIcon, slpIcon };
